import React, { useState, useEffect, useRef, useCallback } from "react";
import DynamicTable from "../../../components/admin/Table";
import { useParams } from "react-router-dom";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";
import { royaltiesService } from "../../../services";

const Royalties = () => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError]= useState(false)
  const [errorMessage, setErrorMessage]= useState(false)
  const { subCat } = useParams();

  const columns = [
    "user",
    "earned",
    "paid",
    "balance",
  ];
 
  // Function to fetch data from the API.
  const fetchData = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await royaltiesService.allRoyalties(subCat);
      const allRoyalties=response.map((royalty) => ({
       ...royalty,
       earned:royalty.totalEarnings || 0,
       paid:royalty.totalPayments || 0,
       user: royalty.owner?.username || "Deleted User",
      }))
      setTableData(allRoyalties);

      //   // Replace this URL with your actual API endpoint.
      //   const response = await fetch(`https://your-api.com/data?page=${pageNumber}`);
      //   const newData = await response.json();
      //setTableData(data);
      //   if (newData.length === 0) {
      //     setHasMore(false);
      //   } else {
      //     setTableData((prev) => [...prev, ...newData]);
      //   }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true)
    }finally{
      setPageLoading(false)
    }
    setLoading(false);
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData(page);
  }, [subCat]);

  // Set up the Intersection Observer to detect when the last row is visible.
  const observer = useRef();
  const lastRowRef = useCallback(
    // (node) => {
    //   if (loading) return;
    //   if (observer.current) observer.current.disconnect();

    //   observer.current = new IntersectionObserver((entries) => {
    //     if (entries[0].isIntersecting && hasMore) {

    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchData(nextPage);
    //     }
    //   });
    //   if (node) observer.current.observe(node);
    // },
    [loading, hasMore, page]
  );

  const actionsMenu = {
  markSeen:false,
  edit:true,
  delete:true,
  customViewLink:"/user/my-royalties/"
  };

  if(pageLoading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>
  if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={`Error ${errorMessage?.title || "Fetching Transactions"} `} message={`There is error while trying to ${setErrorMessage?.message || "fetch the transaction lists"}. Please check your internet contivities and refresh this page to try again`} />
  
  return (
    <>
      {pageLoading ? (
        <div className="grid place-items-center min-h-[100vh]">
          {" "}
          <Spinner />
        </div>
      ) : (
        <div className="p-4 bg-gray-300 mix-blend-multiply h-full min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">All Royalties</h1>

          <div className="overflow-x-auto">
            <DynamicTable
              columns={columns}
              data={tableData}
              url={`/user/royalties`}
              actionsMenu={actionsMenu}
              //   lastRowRef={lastRowRef}
            />
          </div>
          {loading && (
            <div className="flex justify-center mt-4">
              <div
                className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"
                role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!hasMore && (
            <div className="text-center text-gray-500 mt-4">
              No more data to load.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Royalties;
